import type { ReactNode } from "react";

export interface BoardsBandProps {
  children: ReactNode;
  className?: string;
}

/** Dasher-board header band: white board with a 4px rubber-ink kick plate along its bottom edge. */
export function BoardsBand({ children, className = "" }: BoardsBandProps) {
  return (
    <header className={`border-b-4 border-ink bg-board shadow-board py-3 ${className}`}>
      {children}
    </header>
  );
}
